import { useRef, useState, useEffect } from "react";
import { Checkbox, Panel, DefaultButton, TextField, SpinButton, Stack } from "@fluentui/react";
//import { SparkleFilled } from "@fluentui/react-icons";
import fordLogo from "../../assets/fordIcon.png";
import genie from "../../assets/genie.png";
//import { Stack, ActionButton, Icon } from "@fluentui/react";
//import { ChatAdd28Regular, DocumentMargins20Regular } from "@fluentui/react-icons";

import styles from "./Chat.module.css";

import {
    chatApi,
    Approaches,
    AskResponse,
    ChatRequest,
    ChatTurn,
    ConversationMessage,
    sendFeedback,
    resetConversationId,
    getHistory,
    sendFeedbackMessage
} from "../../api";
import { Answer, AnswerError, AnswerLoading } from "../../components/Answer";
import { QuestionInput } from "../../components/QuestionInput";
import { ExampleList } from "../../components/Example";
import { UserChatMessage } from "../../components/UserChatMessage";
import { AnalysisPanel, AnalysisPanelTabs } from "../../components/AnalysisPanel";
import { SettingsButton } from "../../components/SettingsButton";
import { ClearChatButton } from "../../components/ClearChatButton";

import "../../assets/fonts/FordMotion/woff/FordMotion-Regular.woff";

import "../../assets/fonts/ArialNova/ArialNova.ttf";

const Chat = () => {
    const [isConfigPanelOpen, setIsConfigPanelOpen] = useState(false);
    const [promptTemplate, setPromptTemplate] = useState<string>("");
    const [retrieveCount, setRetrieveCount] = useState<number>(9);
    const [useSemanticRanker, setUseSemanticRanker] = useState<boolean>(true);
    const [useSemanticCaptions, setUseSemanticCaptions] = useState<boolean>(false);
    const [excludeCategory, setExcludeCategory] = useState<string>("");
    const [useSuggestFollowupQuestions, setUseSuggestFollowupQuestions] = useState<boolean>(true);

    const lastQuestionRef = useRef<string>("");
    const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>();

    const [activeCitation, setActiveCitation] = useState<string>();
    const [activeAnalysisPanelTab, setActiveAnalysisPanelTab] = useState<AnalysisPanelTabs | undefined>(undefined);

    const [selectedAnswer, setSelectedAnswer] = useState<number>(0);
    const [answers, setAnswers] = useState<ConversationMessage[]>([]);

    const greetings = "Give a greetings to the user by mentioning their name, their role as well as the countries they can access!";

    useEffect(() => {
        console.log("we are in the hook");
        if (sessionStorage.getItem("signout") !== "1") {
            getHistory()
                .then(h => {
                    const n = h.messages.length;
                    lastQuestionRef.current = n > 0 ? h.messages[n - 1].user_input : "";
                    error && setError(undefined);
                    setActiveCitation(undefined);
                    setActiveAnalysisPanelTab(undefined);
                    setAnswers(h.messages);
                })
                .catch(e => {
                    // setError(e.error);
                });
        } else {
            sessionStorage.setItem("signout", "");
            clearChat();
        }
    }, []);

    const makeApiRequest = async (question: string) => {
        lastQuestionRef.current = question;

        error && setError(undefined);
        setIsLoading(true);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);

        try {
            const history: ChatTurn[] = answers.map(a => ({ user: a.user_input, bot: a.bot_input }));
            const request: ChatRequest = {
                history: [...history, { user: question, bot: undefined }],
                approach: Approaches.ReadRetrieveRead,
                overrides: {
                    promptTemplate: promptTemplate.length === 0 ? undefined : promptTemplate,
                    excludeCategory: excludeCategory.length === 0 ? undefined : excludeCategory,
                    top: retrieveCount,
                    semanticRanker: useSemanticRanker,
                    semanticCaptions: useSemanticCaptions,
                    suggestFollowupQuestions: useSuggestFollowupQuestions
                }
            };
            const result = await chatApi(request);
            setAnswers(result.messages);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    };

    const makeApiRequestGreetings = async (question: string) => {
        error && setError(undefined);
        setIsLoading(true);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);

        try {
            const history: ChatTurn[] = answers.map(a => ({ user: a.user_input, bot: a.bot_input }));
            const request: ChatRequest = {
                history: [...history, { user: question, bot: undefined }],
                approach: Approaches.ReadRetrieveRead,
                overrides: {
                    promptTemplate: promptTemplate.length === 0 ? undefined : promptTemplate,
                    excludeCategory: excludeCategory.length === 0 ? undefined : excludeCategory,
                    top: retrieveCount,
                    semanticRanker: useSemanticRanker,
                    semanticCaptions: useSemanticCaptions,
                    suggestFollowupQuestions: useSuggestFollowupQuestions
                }
            };
            const result = await chatApi(request);
            setAnswers(result.messages);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    };
    const onSendFeedback = async (messageId: number, action: string) => {
        const result = await sendFeedback(messageId, action);
        setAnswers(result.messages);
    };
    const onSendFeedbackMessage = async (messageId: number, feedback: string, category: string | null) => {
        const result = await sendFeedbackMessage(messageId, feedback, category);
        setAnswers(result.messages);
    };
    const clearChat = () => {
        lastQuestionRef.current = "";
        error && setError(undefined);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);
        setAnswers([]);
        resetConversationId();
        //makeApiRequestGreetings(greetings);
    };

    useEffect(() => chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" }), [isLoading]);

    const onPromptTemplateChange = (_ev?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        setPromptTemplate(newValue || "");
    };

    const onRetrieveCountChange = (_ev?: React.SyntheticEvent<HTMLElement, Event>, newValue?: string) => {
        setRetrieveCount(parseInt(newValue || "3"));
    };

    const onUseSemanticRankerChange = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        setUseSemanticRanker(!!checked);
    };

    const onUseSemanticCaptionsChange = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        setUseSemanticCaptions(!!checked);
    };

    const onExcludeCategoryChanged = (_ev?: React.FormEvent, newValue?: string) => {
        setExcludeCategory(newValue || "");
    };

    const onUseSuggestFollowupQuestionsChange = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        setUseSuggestFollowupQuestions(!!checked);
    };

    const onExampleClicked = (example: string) => {
        makeApiRequest(example);
    };

    const onShowCitation = (citation: string, index: number) => {
        const content = citation.split("/content/")[1];

        const parts = content.split("_/_");
        const title = parts[0];
        const link = parts[1];

        console.log({ citation, index, content });

        if (content.startsWith("KA-")) {
            const originalString = content;
            const extractedPart = originalString.split(" - ")[0];
            window.open("https://www.lifeatford.com/article/" + extractedPart, "_blank");
            //window.open("https://www.lifeatford.com/article/" + content, "_blank");
        } else {
            var suburl = "";
            if (title == "HRBO Hub" || title.includes("HRBO Hub")) {
                //suburl = "WCM Access Instructions for PLs.pdf";
                suburl = "https://azureford.sharepoint.com/sites/HRBO/SitePages/Compensation-Planning.aspx";
            } else if (
                title == "PL Queries" ||
                title.includes("PL Queries") ||
                title.includes("Degreed") ||
                title.includes("degreed") ||
                title.includes("Chatbot") ||
                title.includes("chatbot")
            ) {
                suburl = "https://degreed.com/plan/1504380?newwindow=true";
            } else {
                suburl = link;
            }
            window.open(suburl, "_blank");
        }
        /*
        if (activeCitation === citation && activeAnalysisPanelTab === AnalysisPanelTabs.CitationTab && selectedAnswer === index) {
            setActiveAnalysisPanelTab(undefined);
        } else {
            setActiveCitation(citation);
            setActiveAnalysisPanelTab(AnalysisPanelTabs.CitationTab);
        }
*/
        setSelectedAnswer(index);
    };

    const onToggleTab = (tab: AnalysisPanelTabs, index: number) => {
        if (activeAnalysisPanelTab === tab && selectedAnswer === index) {
            setActiveAnalysisPanelTab(undefined);
        } else {
            setActiveAnalysisPanelTab(tab);
        }

        setSelectedAnswer(index);
    };
    //<SettingsButton className={styles.commandButton} onClick={() => setIsConfigPanelOpen(!isConfigPanelOpen)} />
    let ignore = false;
    useEffect(() => {
        if (sessionStorage.getItem("firstLoadDone") === null) {
            sessionStorage.setItem("firstLoadDone", "1");
            //makeApiRequestGreetings(greetings);
        }
        return () => {
            ignore = true;
        };
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.chatRoot}>
                <Stack>
                    <div className={styles.chatContainer}>
                        <div className={styles.chatEmptyState}>
                            {/*<img src={fordLogo} alt="Ford Logo" aria-label="Ford" width="160px" height="160px" />*/}
                            <h1 className={styles.chatEmptyStateTitle} style={{ fontFamily: "ArialNova" }}>
                                {/*Welcome to the new Compensation HR ChatGPT (Beta)*/}
                                Welcome to Compensation Planning Genie
                            </h1>
                            <div>
                                <br />
                            </div>
                            <img src={genie} alt="Genie Logo" aria-label="Genie" width="100px" height="142px" />
                            <h3 className={styles.chatEmptyStateSubtitle} style={{ fontFamily: "ArialNova" }}>
                                <span>
                                    <b>The 2026 Compensation Planning Genie pilot has concluded.</b> After supporting over 3,800 compensation planning
                                    conversations during this year's global compensation cycle, the service is now offline. Thank you for your engagement. Genie
                                    looks forward to assisting you again in January 2027!
                                </span>
                                <div>
                                    <br />
                                </div>
                            </h3>
                            {/*<h3 className={styles.chatEmptyStateSubtitle} style={{ fontFamily: "ArialNova" }}>
                                <u>
                                    <b>Compensation Planning Genie Introduction/Disclaimer</b>
                                </u>
                            </h3>
                            <h3 className={styles.chatEmptyStateSubtitle} style={{ fontFamily: "ArialNova" }}>
                                <span>
                                    <b>What is the Compensation Planning Genie which will be called “Genie”.</b> This is a pilot of an Artificial Intelligence
                                    (AI) tool being used by all salaried employees. It is designed to search the Compensation Planning Page of Degreed to
                                    provide answers to general compensation planning questions raised during the Global Compensation Cycle occurring February –
                                    March. Genie should not be used to obtain advice about specific circumstances or individuals. When you are interacting with
                                    Genie, you are interacting with a generative AI tool, not a live person. We recommend that you read the information in the
                                    links identified by Genie in responses.
                                    <br />
                                    <br />
                                    <b>A few things to note about Genie:</b>
                                    <br />
                                    <br />
                                    <b>1. Genie is not Perfect.</b> As this is a pilot of a new AI tool,{" "}
                                    <b>you should not rely on Genie for any important actions or decisions related to compensation planning</b>. In some cases,
                                    Genie may not be able to locate the relevant topic and may not always have the complete and necessary knowledge to answer
                                    your specific question. It is also possible that Genie may provide incorrect or incomplete information. Please use your
                                    discretion to ensure that you receive the correct information and please speak to People First and/or Human Resources (HR)
                                    if appropriate, or if you have questions around eligibility or a specific situation.
                                    <br />
                                    <br />
                                    <b>
                                        2. Add detail to your questions without Personal or Identifiable Information. If you are inquiring about a specific
                                        compensation plan or country it is helpful to mention location in your inquiry.
                                    </b>{" "}
                                    To help Genie answer your question, please provide details (e.g. compensation plan, compensation phase, region/country, SG
                                    or LL, etc.), but please{" "}
                                    <b>
                                        <u>do not</u>
                                    </b>{" "}
                                    ask questions that contain personal data, PII data, or contain specific compensation information or names. Also note that
                                    Genie cannot respond to questions about a specific individual’s compensation award eligibility, how their awards are
                                    calculated, or provide guidance on how to plan their awards.
                                    <br />
                                    <br />
                                    <b>3. Help improve Genie by Providing Feedback.</b> As this is an early version of an AI tool designed to help respond to
                                    People Leader questions, your feedback is valuable to help improve the tool. Please provide anonymous comments and
                                    suggestions using the feedback buttons available with each answer.
                                    <br />
                                    <br />
                                    <b>4. More Information.</b> For further information about how Ford processes your personal information, please refer to
                                    our&nbsp;
                                    <a href="https://www.lifeatford.com/en-US/article/KA-14743" target="_blank">
                                        Employee Privacy Notice
                                    </a>
                                    &nbsp;or request a copy of your local notice in your HR Department.
                                </span>
                                <div>
                                    <br />
                                </div>
                            </h3>*/}
                            {/*<h4 style={{ fontWeight: "600", textAlign: "justify", marginInline: "16%" }}>
                                * If you face any Technical related issue, please kindly report it by clicking&nbsp;
                                <a
                                    href="https://www.itconnect.ford.com/catalog/"
                                    target={"_blank"}
                                    style={{ display: "inline-block", whiteSpace: "nowrap" }}
                                    title="Report any Technical Issue here!"
                                >
                                    <u>here</u>
                                </a>
                                .
    </h4>*/}
                            <div style={{ color: "#2047ef" }}>_________________________________________________</div>
                        </div>

                        <div style={{ overflowY: "inherit", marginBottom: "7%" }}>
                            {!lastQuestionRef.current || lastQuestionRef.current === greetings ? (
                                <div className={styles.chatEmptyState}>
                                    <div className={styles.chatMessageStream}>
                                        {/* {answers.map((answer, index) => (
                                            <div key={index}>
                                                <div className={styles.chatMessageGpt}>
                                                    <Answer
                                                        key={index}
                                                        // messageID={answer.messageId}
                                                        message={answer}
                                                        isSelected={selectedAnswer === index && activeAnalysisPanelTab !== undefined}
                                                        onCitationClicked={c => onShowCitation(c, index)}
                                                        onSendFeedback={onSendFeedback}
                                                        onSendFeedbackMessage={onSendFeedbackMessage}
                                                        // onThoughtProcessClicked={() => onToggleTab(AnalysisPanelTabs.ThoughtProcessTab, index)}
                                                        // onSupportingContentClicked={() => onToggleTab(AnalysisPanelTabs.SupportingContentTab, index)}
                                                        onFollowupQuestionClicked={q => makeApiRequest(q)}
                                                        showFollowupQuestions={useSuggestFollowupQuestions && answers.length - 1 === index}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                        {!isLoading && <ExampleList onExampleClicked={onExampleClicked} />}*/}
                                        {/*<ExampleList onExampleClicked={onExampleClicked} />
                                        {isLoading && (
                                            <>
                                                <div className={styles.chatMessageGptMinWidth}>
                                                    <AnswerLoading greetings={greetings} />
                                                </div>
                                            </>
                                        )}
                                        {error ? (
                                            <>
                                                <div className={styles.chatMessageGptMinWidth}>
                                                    <AnswerError error={error.toString()} onRetry={() => makeApiRequestGreetings(greetings)} />
                                                </div>
                                            </>
                                        ) : null}*/}
                                        <div ref={chatMessageStreamEnd} />
                                    </div>{" "}
                                </div>
                            ) : (
                                <div className={styles.chatMessageStream}>
                                    {answers.map((answer, index) => (
                                        <div key={index}>
                                            <UserChatMessage message={answer.user_input} greetings={greetings} />
                                            <div className={styles.chatMessageGpt}>
                                                <Answer
                                                    key={index}
                                                    // messageID={answer.messageId}
                                                    message={answer}
                                                    isSelected={selectedAnswer === index && activeAnalysisPanelTab !== undefined}
                                                    onCitationClicked={c => onShowCitation(c, index)}
                                                    onSendFeedback={onSendFeedback}
                                                    onSendFeedbackMessage={onSendFeedbackMessage}
                                                    // onThoughtProcessClicked={() => onToggleTab(AnalysisPanelTabs.ThoughtProcessTab, index)}
                                                    // onSupportingContentClicked={() => onToggleTab(AnalysisPanelTabs.SupportingContentTab, index)}
                                                    onFollowupQuestionClicked={q => makeApiRequest(q)}
                                                    showFollowupQuestions={useSuggestFollowupQuestions && answers.length - 1 === index}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                    {isLoading && (
                                        <>
                                            <UserChatMessage message={lastQuestionRef.current} greetings={greetings} />
                                            <div className={styles.chatMessageGptMinWidth}>
                                                <AnswerLoading />
                                            </div>
                                        </>
                                    )}
                                    {error ? (
                                        <>
                                            <UserChatMessage message={lastQuestionRef.current} greetings={greetings} />
                                            <div className={styles.chatMessageGptMinWidth}>
                                                <AnswerError error={error.toString()} onRetry={() => makeApiRequest(lastQuestionRef.current)} />
                                            </div>
                                        </>
                                    ) : null}
                                    <div ref={chatMessageStreamEnd} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={styles.chatContainerQuestion} style={{ display: "none" }}>
                        <div className={styles.chatInputBackground}></div>
                        <div className={styles.chatInput}>
                            <QuestionInput
                                clearOnSend
                                placeholder="Type a new question here..."
                                disabled={isLoading}
                                onSend={question => makeApiRequest(question)}
                                onNewChatButtonClick={clearChat}
                                currentQuestion={lastQuestionRef.current}
                                greetings={greetings}
                                isLoading={isLoading}
                            />
                        </div>
                    </div>
                </Stack>

                {/* {answers.length > 0 && activeAnalysisPanelTab && (
                    <AnalysisPanel
                        className={styles.chatAnalysisPanel}
                        activeCitation={activeCitation}
                        onActiveTabChanged={x => onToggleTab(x, selectedAnswer)}
                        citationHeight="810px"
                        answer={answers[selectedAnswer][1]}
                        activeTab={activeAnalysisPanelTab}
                    />
                )} */}

                <Panel
                    headerText="Configure answer generation"
                    isOpen={isConfigPanelOpen}
                    isBlocking={false}
                    onDismiss={() => setIsConfigPanelOpen(false)}
                    closeButtonAriaLabel="Close"
                    onRenderFooterContent={() => <DefaultButton onClick={() => setIsConfigPanelOpen(false)}>Close</DefaultButton>}
                    isFooterAtBottom={true}
                >
                    <TextField
                        className={styles.chatSettingsSeparator}
                        defaultValue={promptTemplate}
                        label="Override prompt template"
                        multiline
                        autoAdjustHeight
                        onChange={onPromptTemplateChange}
                    />

                    <SpinButton
                        className={styles.chatSettingsSeparator}
                        label="Retrieve this many documents from search:"
                        min={1}
                        max={50}
                        defaultValue={retrieveCount.toString()}
                        onChange={onRetrieveCountChange}
                    />
                    <TextField
                        className={styles.chatSettingsSeparator}
                        label="Webroles Filter (Ex Format: Global, Global HR)"
                        onChange={onExcludeCategoryChanged}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={useSemanticRanker}
                        label="Use semantic ranker for retrieval"
                        onChange={onUseSemanticRankerChange}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={useSemanticCaptions}
                        label="Use query-contextual summaries instead of whole documents"
                        onChange={onUseSemanticCaptionsChange}
                        disabled={!useSemanticRanker}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={useSuggestFollowupQuestions}
                        label="Suggest follow-up questions"
                        onChange={onUseSuggestFollowupQuestionsChange}
                    />
                </Panel>
            </div>
        </div>
    );
};

export default Chat;
